import { Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import logoAnna from "../img/La_psicologa.webp";
import "./Footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <div className="footer__logo">
            <img
              src={logoAnna}
              alt="Logo La Psicologa Anna"
              loading="lazy"
              decoding="async"
              width={1148}
              height={353}
            />
          </div>
          <p className="footer__tagline">
            Sostegno psicologico a Rieti e online. Uno spazio di ascolto per
            ritrovare il tuo equilibrio.
          </p>
          <div className="footer__social">
            <a
              href="https://www.instagram.com/lapsicologaanna/"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://www.linkedin.com/in/anna-antoniozzi-5429a9236/"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </div>

        <div className="footer__col">
          <h3 className="footer__title">Contatti</h3>
          <a className="footer__row" href="tel:+393791566652">
            <Phone size={17} /> +39 379 156 6652
          </a>
          <a
            className="footer__row"
            href="mailto:annaantoniozzipsicologa@gmail.com"
          >
            <Mail size={17} /> annaantoniozzipsicologa@gmail.com
          </a>
          <a
            className="footer__row"
            href="https://www.google.com/maps/search/?api=1&query=42.40418065464321%2C12.851407020320385"
            target="_blank"
            rel="noreferrer noopener"
          >
            <MapPin size={17} /> Via Fundania 2, Rieti (RI) 02100 - C.C. Perseo,
            Torre A
          </a>
        </div>

        <div className="footer__col">
          <h3 className="footer__title">Naviga</h3>
          <Link className="footer__link" to="/chi-sono">
            Chi sono
          </Link>
          <Link className="footer__link" to="/servizi">
            Servizi
          </Link>
          <Link className="footer__link" to="/prenota-appuntamento">
            Prenota
          </Link>
          <Link className="footer__link" to="/faq">
            FAQ
          </Link>
        </div>
      </div>

      <div className="container footer__bottom">
        <p>© {currentYear} La Psicologa Anna · P.IVA 01254800574</p>
        <div className="footer__legal">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/cookie-policy">Cookie Policy</Link>
        </div>
      </div>
    </footer>
  );
}
